<ng-container *ngIf="resendActivationAccountLink$ | async"></ng-container>

<section class="verifying-email">
  <h1 class="verifying-email__title">
    {{ 'verifying-email.title' | translate }}
  </h1>

  <div class="verifying-email__content">
    <p class="verifying-email__card verifying-email__card-text">
      <span
        [innerHTML]="'verifying-email.text.how-activate' | translate : howActivateParams"></span>
      <span [innerHTML]="'verifying-email.text.expiration-link' | translate"></span>
    </p>

    <div class="resend-link-btn">
      <mat-icon *ngIf="isCompleteResendActivationLink">check</mat-icon>
      <a class="resend-link-btn__text" (click)="onResendActivationLink($event)">
        {{ 'buttons.resend-verifying-email' | translate }}
      </a>
    </div>
  </div>
</section>

<app-sign-in-mobile-footer />
